export const fmt = (n: number | null | undefined, d = 2) =>
  n === null || n === undefined || Number.isNaN(n)
    ? "—"
    : n.toLocaleString("sr-RS", { minimumFractionDigits: d, maximumFractionDigits: d });

export const STATUS_LABEL: Record<string, string> = {
  DRAFT: "Nacrt",
  CALCULATED: "Obračunato",
  PENDING_APPROVAL: "Na odobravanju",
  APPROVED: "Odobreno",
  POSTED: "Proknjiženo",
  CANCELLED: "Otkazano",
};

export const STATUS_STYLE: Record<string, string> = {
  DRAFT: "bg-slate-100 text-slate-700",
  CALCULATED: "bg-sky-100 text-sky-700",
  PENDING_APPROVAL: "bg-amber-100 text-amber-700",
  APPROVED: "bg-indigo-100 text-indigo-700",
  POSTED: "bg-emerald-100 text-emerald-700",
  CANCELLED: "bg-red-100 text-red-700",
};

export const TYPE_LABEL: Record<string, string> = {
  RECEIPT: "Prijemna kalkulacija",
  IMPORT: "Uvozna kalkulacija",
  PRICE_CHANGE: "Promena cena",
};
